import { StyledList } from '../../Basic/Lists/VerticalList/VerticalList.styles.mjs';
import styled from 'styled-components';

const StyledAccordionHeading = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  svg {
    transition-property: all;
    transition-duration: ${props => props.theme.animation.duration.moderate1};
    transform: ${props => (props.isOpen ? 'scaleY(-1)' : 'scaleY(1)')};
    transition-timing-function: ${props => props.isOpen
    ? props.theme.animation.easing.productive.entrance
    : props.theme.animation.easing.productive.exit};
  }
`;
const StyledAccordionBody = styled.div `
  overflow: hidden;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  max-height: ${props => (props.isOpen ? '500px' : 0)};
  transition-property: all;
  transition-duration: ${props => props.theme.animation.duration.moderate1};
  transition-timing-function: ${props => props.isOpen
    ? props.theme.animation.easing.productive.entrance
    : props.theme.animation.easing.productive.exit};

  ${StyledList} {
    padding-top: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 0;
  }
`;

export { StyledAccordionBody, StyledAccordionHeading };
//# sourceMappingURL=VerticalAccordion.styles.mjs.map
